import React from 'react';
import styles from './index.css';
class AccountOpening extends React.PureComponent {
    render() {
        const { content } = this.props;
        const account = content[0];
        const transaction = content[1];
        return (React.createElement("div", { className: styles.box },
            React.createElement("a", { className: styles.box_L, href: account.url },
                React.createElement("span", { className: styles.title }, account.title),
                React.createElement("span", { className: styles.account_icon })),
            React.createElement("a", { className: styles.box_R, href: transaction.url },
                React.createElement("span", { className: styles.title }, transaction.title),
                React.createElement("span", { className: styles.transaction_icon }))));
    }
}
export default AccountOpening;
